module.exports = __webpack_public_path__ + "img/boy.635563ba.png";